const FireDoorCompliance = {
    title: "New Fire Door Compliance",
};
export default FireDoorCompliance;
